import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import NoHome from '../components/NoHome';

function NoHomeContainer({ currentWorkspaceId, me }) {
  if (currentWorkspaceId) {
    return <Redirect to={`/w/${currentWorkspaceId}/dashboard`} />;
  }

  // identity.me is normalized, so workspaces and accounts hold ids
  if (me.workspaces?.length > 0) {
    return <Redirect to={`/w/${me.workspaces[0]}/dashboard`} />;
  }

  if (me.accounts?.length > 0) {
    return <Redirect to={`/a/${me.accounts[0]}`} />;
  }

  return <NoHome />;
}

export default connect(({ currentWorkspaceId, identity: { me } }) => {
  return { currentWorkspaceId, me };
}, {})(NoHomeContainer);
